var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPaidAppsLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 100,
    viewBox: "0 0 117 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 24,
    height: 25,
    rx: 4,
    fill: "#FDBD90"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 61,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFEADB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FDBD90"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 24,
    height: 25,
    rx: 4,
    fill: "#FFEADB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 61,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FDBD90"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 25,
    height: 24,
    rx: 4,
    fill: "#FFEADB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 25,
    height: 25,
    rx: 4,
    fill: "#FDBD90"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 61,
    width: 25,
    height: 24,
    rx: 4,
    fill: "#FFEADB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.47 96.1614C116.462 98.2792 114.741 99.9912 112.612 100H57.3641C56.2997 100 55.333 99.5676 54.6412 98.8705C53.9405 98.1822 53.5059 97.2203 53.5059 96.1614C53.5059 95.4377 53.7099 94.7318 54.0824 94.1141L55.4926 91.8638L57.7455 88.2634L57.781 88.2016C58.2422 87.2927 58.4816 86.2867 58.4816 85.2631V67.0316C58.4816 63.29 59.4484 59.7602 61.1514 56.6981C61.5505 55.9657 62.0028 55.2597 62.4907 54.5891C64.7967 51.3593 67.9986 48.8002 71.7238 47.2559C72.593 46.8941 73.4977 46.5852 74.429 46.3381C75.0676 46.1705 75.724 46.0205 76.3803 45.9146C77.5599 45.7116 78.7751 45.6057 80.0168 45.6057H89.9595C91.7334 45.6057 93.4629 45.8175 95.1127 46.2234C104.514 48.5178 111.495 56.9629 111.495 67.0316V85.2631C111.495 85.3955 111.495 85.5278 111.504 85.6602C111.557 86.5515 111.796 87.4074 112.195 88.2016L115.885 94.1141C116.266 94.7318 116.47 95.4377 116.47 96.1614Z",
    fill: "#E62645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4501 76.8333C89.5193 76.8333 91.2623 76.0648 92.6791 74.5278L95 76.75C94.1052 77.8056 92.9867 78.6111 91.6445 79.1667C90.3209 79.7222 88.8575 80 87.2543 80C85.6325 80 84.1225 79.7037 82.7244 79.1111C81.3449 78.5185 80.1704 77.6852 79.2011 76.6111C78.2503 75.537 77.5792 74.2963 77.1878 72.8889H74V70.9444H76.8242C76.8056 70.7407 76.7963 70.4259 76.7963 70C76.7963 69.5741 76.8056 69.2593 76.8242 69.0556H74V67.1111H77.1878C77.5792 65.7037 78.2503 64.463 79.2011 63.3889C80.1704 62.3148 81.3449 61.4815 82.7244 60.8889C84.1225 60.2963 85.6325 60 87.2543 60C88.8575 60 90.3209 60.2778 91.6445 60.8333C92.9867 61.3889 94.1052 62.1944 95 63.25L92.6791 65.4444C91.2623 63.9259 89.5193 63.1667 87.4501 63.1667C85.9587 63.1667 84.6445 63.5185 83.5073 64.2222C82.3888 64.9259 81.5593 65.8889 81.0186 67.1111H89.0439V69.0556H80.4874C80.4501 69.463 80.4314 69.7778 80.4314 70C80.4314 70.2222 80.4501 70.537 80.4874 70.9444H89.0439V72.8889H81.0186C81.5593 74.1111 82.3888 75.0741 83.5073 75.7778C84.6445 76.4815 85.9587 76.8333 87.4501 76.8333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2434 34.0632L90.3229 45.0939L89.9592 45.6057V48.4384C88.753 48.7119 87.2363 48.8972 85.3116 48.8972H85.0012C82.8903 48.8796 81.2583 48.7208 80.0165 48.4648V45.6057L79.6972 45.1645L71.7324 34.0632H98.2434Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.47 96.1613C116.462 98.2792 114.741 99.9912 112.612 100H57.3641C56.2997 100 55.333 99.5676 54.6412 98.8705C53.9405 98.1821 53.5059 97.2203 53.5059 96.1613C53.5059 95.4377 53.7099 94.7318 54.0824 94.114L55.4926 91.8638C57.3907 93.9905 61.3908 95.6407 69.2581 95.5436C90.7932 95.2877 102.59 94.5288 108.222 89.2959C109.464 88.1487 110.563 86.9044 111.504 85.6602C111.557 86.5514 111.796 87.4074 112.195 88.2016L115.885 94.114C116.266 94.7318 116.47 95.4377 116.47 96.1613Z",
    fill: "#A7163E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1132 46.2233C94.4303 46.0733 93.5522 47.644 89.96 48.4382C88.7538 48.7118 87.2371 48.8971 85.3124 48.8971H85.002C82.8911 48.8795 81.2591 48.7206 80.0173 48.4647C77.4452 47.9264 76.5228 46.9734 76.3809 45.9144C77.5605 45.7115 78.7756 45.6056 80.0173 45.6056L79.698 45.1643C82.8822 45.4203 87.6451 45.6673 90.3237 45.0938L89.96 45.6056C91.7339 45.6056 93.4635 45.8174 95.1132 46.2233Z",
    fill: "#A7163E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7324 34.0632C71.7324 34.0632 89.9504 28.0184 95.1124 30.6746C100.274 33.3308 98.2434 34.0632 98.2434 34.0632C98.2434 34.0632 85.6487 40.6639 71.7324 34.0632Z",
    fill: "#A7163E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaidAppsLicense);
export default __webpack_public_path__ + "static/media/imgPaidAppsLicense.404a4d53ccf20865f793e41307473e16.svg";
export { ForwardRef as ReactComponent };